import React, { Component } from 'react';
import TrackVisibility from 'react-on-screen';

import config from '@config';
import ProgramsList from './../programslist';

class Grid extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.dispatchEvent(new Event(config.events.renderedGrid));
  }

  componentDidUpdate() {
    window.dispatchEvent(new Event(config.events.renderedGrid));
  }

  render() {
    return (
      <div
        className="tvg-grid"
        style={{
          width: `${this.props.gridWidth}px`,
        }}
      >
        <ul className="tvg-grid__programs">
          {this.props.channels.map(c => (
            <TrackVisibility
              offset={config.visibilityTrackingOffset}
              partialVisibility
              key={c.service_id}
              className="tvg-grid__programs__line"
              tag="li"
              throttleInterval={500}
            >
              {({ isVisible }) =>
                isVisible && <ProgramsList sid={c.service_id} />
              }
            </TrackVisibility>
          ))}
        </ul>
      </div>
    );
  }
}

export default Grid;
